(() => {
  const API_URL = 'https://4z5p4wqpl0.execute-api.eu-west-3.amazonaws.com/prod/register/b2b-form';

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  function deleteCookie(name) {
    document.cookie = name + '=;path=/;max-age=0;SameSite=Lax';
  }

  var email = getCookie('b2b_pro_email');
  if (!email) return;

  deleteCookie('b2b_pro_email');

  fetch(API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email: email }),
  }).catch(function () {});
})();
